import { useState, useEffect } from "react";

const useFormState = (initialState, initialValues = {}) => {
  const [formValues, setFormValues] = useState(initialState);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const areAllFieldsFilled = Object.values(formValues).every((value) => {
      return typeof value === "string" ? value.trim() : value !== null && value !== undefined;
    });

    setIsButtonDisabled(!areAllFieldsFilled);
  }, [formValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return { formValues, handleChange, isButtonDisabled, setFormValues };
};

export default useFormState;
